<template>
  <div class="edit-wrap">
    <el-form :model="tfContent" :rules="rules" ref="tfcontentRef">
      <div class="item-card">
        <div class="card-title">广告名称</div>
        <div class="card-content">
          <ul class="modal-form">
            <li class="form-item">
              <span class="form-label require" style="padding-top: 6px">广告名称：</span>
              <div class="form-value">
                <select-input
                  ref="selectInputRef"
                  placeholder="(必填)请输入广告组名称"
                  :dataList="adGroupList"
                  v-model="tfContent.nameRule"
                ></select-input>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="item-card">
        <div class="card-title">推广应用</div>
        <div class="card-content">
          <ul class="modal-form">
            <li class="form-item">
              <span class="form-label require" style="padding-top: 6px">应用ID：</span>
              <div class="form-value">
                <el-form-item prop="promotedObjectId" style="margin-bottom: 0px">
                  <el-select popper-class="edit-base-set-appid-select" v-model="tfContent.promotedObjectId" placeholder="请选择应用ID">
                    <div style="display: flex;text-align: end;margin: 8px 12px 8px">
                      <el-input @input="dropDownSearch" style="flex: 1" v-model="promotedObjectAsyncId" placeholder="请输入内容"></el-input>
                      <div
                        @click="getAppList({ promotedObjectId: promotedObjectAsyncId, isSync: true })"
                        style="color:#0b75ff;font-size: 13px;cursor: pointer;width: 30px;line-height: 30px;"
                      >
                        同步
                      </div>
                    </div>
                    <el-option
                      style="margin-bottom: 8px"
                      v-for="item in appidList"
                      :key="item.promotedObjectId"
                      :value="item.promotedObjectId"
                      :label="item.promotedObjectName + '(' + item.promotedObjectId + ')'"
                    >
                      <div class="seitem-wrap">
                        <div class="img-wrap">
                          <img class="app-img" :src="item.iconUrl" />
                        </div>
                        <div class="seitem-content">
                          <span class="app-detail">{{ item.promotedObjectName }}</span>
                          <span class="app-detail">({{ item.promotedObjectId }})</span>
                        </div>
                        <svg-icon
                          :iconClass="
                            item.promotedObjectType === 'APP_ANDROID' ? 'android' : item.promotedObjectType === 'APP_IOS' ? 'apple' : ''
                          "
                          className="os-icon"
                        ></svg-icon>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </li>
            <li class="form-item" v-if="promotedObjectType === 'APP_ANDROID'">
              <span class="form-label" style="padding-top: 6px">渠道包：</span>
              <div class="form-value">
                <el-form-item style="margin-bottom: 0px">
                  <el-alert
                    class="alert"
                    style="height: 28px;width: 200px"
                    :closable="false"
                    title=" 渠道包不选择即主线包"
                    type="warning"
                    show-icon
                  >
                  </el-alert>
                  <el-radio-group v-model="tfContent.channelPackageType" size="small">
                    <el-radio-button label="ALL">全部相同</el-radio-button>
                    <el-radio-button label="ACCOUNT">分配到账户</el-radio-button>
                  </el-radio-group>
                  <div>
                    <el-select
                      v-if="tfContent.channelPackageType === 'ALL'"
                      v-model="tfContent.channelPackageItems"
                      placeholder="请选择推广的应用名称"
                      filterable
                    >
                      <el-option
                        v-for="item of sameChannelList"
                        :key="item.appAndroidChannelPackageId"
                        :value="item.appAndroidChannelPackageId"
                        :label="item.packageName"
                      >
                        {{ item.packageName }}
                      </el-option>
                    </el-select>
                    <el-table v-else :data="tfContent.channelPackageItems" style="width: 502px" border size="mini">
                      <el-table-column prop="company" label="广告账户" width="200">
                        <template slot-scope="scope">
                          <div>{{ scope.row.company }}</div>
                          <div>ID：{{ scope.row.sourceAccountId }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="name" label="渠道包" width="300">
                        <template slot-scope="scope">
                          <el-select
                            popper-class="edit-base-set-appid-select"
                            v-model="scope.row.appAndroidChannelPackageId"
                            placeholder="请选择推广的应用名称"
                            filterable
                          >
                            <div style="display: flex;text-align: end;margin: 8px 12px 8px">
                              <el-input
                                @input="dropDownSearchChannel(scope.row.sourceAccountId)"
                                style="flex: 1"
                                v-model="channelAsyncId"
                                placeholder="请输入内容"
                              ></el-input>
                              <div
                                @click="getChannelPackage({ promotedObjectId: channelAsyncId })"
                                style="color:#0b75ff;font-size: 13px;cursor: pointer;width: 30px;line-height: 30px;"
                              >
                                同步
                              </div>
                            </div>
                            <el-option
                              v-for="item in channelList[scope.row.sourceAccountId]"
                              :key="item.appAndroidChannelPackageId"
                              :label="item.packageName"
                              :value="item.appAndroidChannelPackageId"
                            >
                            </el-option>
                          </el-select>
                          <el-tooltip
                            style="margin-left: 20px"
                            class="item"
                            effect="dark"
                            content="不支持旧版微信朋友圈推广计划"
                            placement="top-start"
                          >
                            <i class="el-icon-question"></i>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-form-item>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="item-card">
        <div class="card-title">广告版位</div>
        <div class="card-content">
          <ul class="modal-form">
            <li class="form-item">
              <div class="form-value">
                <el-radio-group v-model="tfContent.placementType" size="small">
                  <el-radio-button label="AUTO">自动版位</el-radio-button>
                  <el-radio-button label="VIDEO">按媒体选择</el-radio-button>
                  <el-radio-button label="GAME">按游戏场景</el-radio-button>
                </el-radio-group>
              </div>
            </li>
            <div v-if="tfContent.placementType === 'AUTO'" class="custom-tip">
              <div>1、使用自动版位时，腾讯广告将根据您的设置，选择表现更好的位置进行投放，并帮您触达尽可能多的目标用户</div>
              <div>2、自动版位暂不支持包括微信朋友圈、微信公众号与小程序、应用宝、PC等版位，如需投放可在特定版位中选择</div>
            </div>
            <div v-else>
              <!-- 多选内容 -->
              <div class="ad-part" :class="{ 'select-border': tfContent.videoCheckList.length > 0 }">
                <div class="multi-tag">可多选</div>
                <el-checkbox-group v-model="tfContent.videoCheckList" v-if="tfContent.placementType === 'VIDEO'" @change="changeMultiVideo">
                  <el-checkbox class="check-item" v-for="item in videoSelectListOptions" :label="item.value" :key="item.value">{{
                    item.label
                  }}</el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group v-model="tfContent.gameCheckList" v-else>
                  <el-checkbox class="check-item" v-for="item in gameSelectListOptions" :label="item.value" :key="item.value">{{
                    item.label
                  }}</el-checkbox>
                </el-checkbox-group>
                <div v-if="tfContent.placementType === 'VIDEO' && tfContent.videoCheckList.includes('SITE_SET_MOBILE_UNION')">
                  <div class="form-item scren">
                    <span class="form-label" style="padding-top: 6px">展示场景：</span>
                    <div class="form-value">
                      <el-radio-group v-model="tfContent.displaySceneMode" size="small">
                        <el-radio-button label="NOLIMIIT">不限</el-radio-button>
                        <el-radio-button label="CUSTOM" :disabled="tfContent.placement.flowOptimizationEnabled">自定义</el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>
                  <div class="form-item" v-if="tfContent.displaySceneMode === 'CUSTOM'">
                    <div class="form-value">
                      <el-checkbox-group v-model="tfContent.placement.displayScene">
                        <el-checkbox v-for="item in spreadSelectList" :label="item.value" :key="item.value">{{ item.label }}</el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div class="form-item">
                    <div class="form-value">
                      <span class="form-label" style="padding-top: 6px;width: 140px">优量汇智能游戏匹配：</span>
                      <el-switch
                        :disabled="tfContent.displaySceneMode === 'CUSTOM'"
                        v-model="tfContent.placement.flowOptimizationEnabled"
                        active-color="#0b75ff"
                      >
                      </el-switch>
                    </div>
                  </div>
                  <el-alert
                    class="alert"
                    :closable="false"
                    title="智能流量匹配需要开通白名单，请确保所选账户已开通对应权限"
                    type="warning"
                    show-icon
                  >
                  </el-alert>
                </div>
              </div>
              <!-- 单选内容 -->
              <div v-if="tfContent.placementType === 'VIDEO'">
                <div
                  :class="{ 'select-border': tfContent.videoOtherSelect === 'SITE_SET_MOMENTS' }"
                  class="wx-friend"
                  @click="changeRadioVideo('SITE_SET_MOMENTS')"
                >
                  <el-radio v-model="tfContent.videoOtherSelect" label="SITE_SET_MOMENTS">微信朋友圈</el-radio>
                  <div class="multi-tag">可单选</div>
                </div>
                <div
                  class="wx-friend"
                  :class="{ 'select-border': tfContent.videoOtherSelect === 'SITE_SET_QQSHOPPING' }"
                  @click="changeRadioVideo('SITE_SET_QQSHOPPING')"
                >
                  <el-radio v-model="tfContent.videoOtherSelect" label="SITE_SET_QQSHOPPING">QQ购物</el-radio>
                  <div class="multi-tag">可单选</div>
                </div>
              </div>
              <div class="view-example">
                <a class="a-url" href="https://e.qq.com/ads/helpcenter/detail?cid=576&amp;pid=1724" target="_blank"
                  >查看各个版位的广告展示样式</a
                >
              </div>
            </div>
          </ul>
        </div>
      </div>
      <div class="item-card">
        <div class="card-title">定向拓展</div>
        <div class="card-content">
          <ul class="modal-form">
            <!-- <li class="form-item">
              <div class="form-value">
                <span class="form-label" style="padding-top: 6px;width: 120px"
                  >系统优选
                  <el-tooltip style="margin-left: 5px" class="item" effect="dark" placement="top-start">
                    <template #content>
                      <div>不可与自动拓量、微信朋友圈版位同时使用。</div>
                      <div>且开启后不可使用自定义人群与兴趣行为定向，媒体定向包</div>
                    </template>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                  ：</span
                >
                <el-switch v-model="tfContent.autoAudience" @change="changeSystemPicker" active-color="#0b75ff"> </el-switch>
              </div>
            </li> -->
            <li class="form-item">
              <div class="form-value">
                <span class="form-label" style="padding-top: 6px;width: 120px"
                  >自动扩量
                  <el-tooltip style="margin-left: 5px" class="item" effect="dark" placement="top-start">
                    <template #content>
                      <div>当能够将您的广告投放给更多合适的人群时，系统会在您所选的定向人群外，自动扩展人群。</div>
                      <div>不可与系统优选同时使用；跨账户选择扩量种子人群时请确保所有账户均有使用权限</div>
                    </template>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                  ：</span
                >
                <el-switch
                  @change="tfContent.expandTargeting = []"
                  v-model="tfContent.expandEnabled"
                  :disabled="tfContent.autoAudience"
                  active-color="#0b75ff"
                >
                </el-switch>
              </div>
            </li>
            <div v-if="tfContent.expandEnabled">
              <li class="form-item">
                <div class="form-value">
                  <span class="form-label" style="padding-top: 6px;width: 140px">可指定不可突破定向：</span>
                  <el-checkbox-group v-model="tfContent.expandTargeting" style="display: inline-block">
                    <el-checkbox class="check-item" label="age" key="age">年龄</el-checkbox>
                    <el-checkbox class="check-item" label="gender" key="gender">性别</el-checkbox>
                    <el-checkbox class="check-item" label="geo_location" key="geo_location">地理位置</el-checkbox>
                  </el-checkbox-group>
                  <el-tooltip effect="dark" style="margin-left: 5px" placement="top-start">
                    <template #content>
                      <div>您可以指定不可突破定向，例如您地域定向选择了</div>
                      <div>上海，同时又选择了地域为不可突破定向，系统在</div>
                      <div>自动扩量阶段，将不会把广告展示给非上海地区的</div>
                      <div>用户。若无此类特殊需求，不建议勾选不可突破定向</div>
                    </template>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </div>
              </li>
              <li class="form-item">
                <span class="form-label" style="padding-top: 6px; width: 140px">扩量种子人群：</span>
                <div class="form-value">
                  <el-form-item style="margin-bottom: 0px">
                    <el-select
                      popper-class="edit-base-set-appid-select"
                      v-model="tfContent.coldStartAudience"
                      placeholder="请选择扩量种子人群"
                      filterable
                    >
                      <el-option v-for="item of coldStartAudienceList" :key="item.value" :value="item.value" :label="item.label">
                        {{ item.label }}
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </li>
            </div>
          </ul>
        </div>
      </div>
      <div class="item-card">
        <div class="card-title">创意元素配置</div>
        <div v-show="tfContent.promotedObjectId" class="card-content">
          <ul class="modal-form">
            <li class="form-item">
              <span class="form-label require" style="padding-top: 6px;width: 140px">创意名称：</span>
              <div class="form-value">
                <select-input
                  ref="selectCreateNameRef"
                  placeholder="(必填)请输入创意名称"
                  :dataList="createNameGroupList"
                  v-model="tfContent.adNameRule"
                ></select-input>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 6px;width: 140px">创意形式：</span>
              <div class="form-value">
                <el-radio-group v-model="tfContent.isDynamicCreative" size="small">
                  <el-radio-button :label="false">自定义</el-radio-button>
                  <el-radio-button :label="true">动态创意</el-radio-button>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 6px;width: 140px">创意展现：</span>
              <div class="form-value">
                <el-radio-group v-model="tfContent.creativeDisplayType" size="small">
                  <el-radio-button label="INTELLIGENCE">优选模式</el-radio-button>
                  <el-radio-button label="AVERAGE">轮播模式</el-radio-button>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 6px;width: 140px">自动衍生视频创意：</span>
              <div class="form-value">
                <el-radio-group v-model="tfContent.autoDerivedCreativeEnabled" size="small">
                  <el-radio-button :label="false">关闭</el-radio-button>
                  <el-radio-button :label="true">开启</el-radio-button>
                </el-radio-group>
              </div>
            </li>
            <div v-if="tfContent.placementType !== 'GAME'">
              <li class="form-item">
                <span class="form-label" style="padding-top: 6px;width: 140px"
                  >标签
                  <el-tooltip style="margin-left: 5px" class="item" effect="dark" placement="top-start">
                    <template #content>
                      <div>标签总字数需在15字以内，中英文均算1个字，最多可选择3个标签</div>
                    </template>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                  ：</span
                >
                <div class="form-value">
                  <el-form-item prop="labels" style="margin-bottom: 0px">
                    <el-cascader
                      v-model="tfContent.labels"
                      style="width: 400px"
                      placeholder="请选择标签，最多三个"
                      :show-all-levels="false"
                      clearable
                      allow-create
                      :options="labelListOptions"
                      :props="{ multiple: true, emitPath: false }"
                      filterable
                    ></el-cascader>
                    <span style="margin-left: 8px;color: #0b75ff;cursor: pointer" @click="showAddCustomLabelDialog">自定义</span>
                  </el-form-item>
                </div>
              </li>
              <li class="form-item">
                <span class="form-label" style="padding-top: 6px;width: 140px">按钮文案：</span>
                <div class="form-value">
                  <el-form-item prop="buttonText" style="margin-bottom: 0px;width: 300px;">
                    <el-select v-model="tfContent.buttonText" placeholder="请选择按钮文案" filterable>
                      <el-option v-for="item of buttonTextList" :key="item" :value="item" :label="item">
                        {{ item }}
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </li>
            </div>
            <li class="form-item">
              <span class="form-label require" style="padding-top: 6px;width: 140px">品牌形象：</span>
              <div class="form-value">
                <el-form-item prop="brandImgId" style="margin-bottom: 0px;width: 300px;">
                  <el-select
                    popper-class="edit-base-set-appid-select"
                    v-model="tfContent.brandImgId"
                    placeholder="请选择品牌形象"
                    filterable
                  >
                    <el-option v-for="item of brandImageList" :key="item.imageId" :value="item.imageId" :label="item.name">
                      <div class="seitem-wrap">
                        <div class="img-wrap">
                          <img class="app-img" :src="item.imageUrl" />
                        </div>
                        <div style="flex: 1">{{ item.name }}</div>
                        <!-- <div @click.stop="deleteBrandImage('brand', item)"><i class="el-icon-close"></i></div> -->
                      </div>
                    </el-option>
                  </el-select>
                  <span style="margin-left: 8px;color: #0b75ff;cursor: pointer" @click="showAddProductFigureDialog('brand')">创建品牌</span>
                </el-form-item>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 6px;width: 140px">挂件图：</span>
              <div class="form-value">
                <el-form-item prop="pendantImageId" style="margin-bottom: 0px;width: 300px;">
                  <el-select
                    popper-class="edit-base-set-appid-select"
                    v-model="tfContent.pendantImageId"
                    placeholder="请选择挂件图"
                    filterable
                  >
                    <el-option v-for="item of pendantImageList" :key="item.id" :value="item" :label="item.name">
                      <div class="seitem-wrap">
                        <div class="img-wrap">
                          <img class="app-img" :src="item.imageUrl" />
                        </div>
                        <div style="flex: 1">{{ item.name }}</div>
                        <div @click.stop="deleteBrandImage('pendant', item)"><i class="el-icon-close"></i></div>
                      </div>
                    </el-option>
                  </el-select>
                  <span style="margin-left: 8px;color: #0b75ff;cursor: pointer" @click="showAddProductFigureDialog('pendant')"
                    >创建挂件图</span
                  >
                </el-form-item>
              </div>
            </li>
          </ul>
        </div>
        <div class="empty-content" v-if="!tfContent.promotedObjectId">
          请先选账户与推广应用
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import nameTransforUtil from "./common/nameTransforUtil.js";
import SvgIcon from "@/components/SvgIcon.vue";
import SelectInput from "./common/selectInput.vue";
import { videoSelectListOptions, spreadSelectList, gameSelectListOptions, buttonTextList } from "./common/config";
import {
  getPromotedAppList,
  getChannelPackageList,
  getPromotedLabelList,
  getImageTemplatelList,
  getBrandAppList,
  deltetImageTemplatel,
} from "@/api/promotion-gdt.js";

export default {
  components: {
    SvgIcon,
    SelectInput,
  },
  data() {
    return {
      videoSelectListOptions,
      spreadSelectList,
      promotedObjectAsyncId: "",
      buttonTextList,
      gameSelectListOptions,
      showMore: false,
      selectItem: [0, 1],
      creativeNameSelectItem: [0, 1],
      adGroupList: [
        "推广目标",
        "版位",
        "创意组",
        "落地页",
        "定向包",
        "自动拓量",
        "开始时间",
        "计费方式",
        "出价策略",
        "优化目标",
        "深度优化",
        "目标出价",
        "广告日预算",
        "首个视频名称",
        "首个图片名称",
        "创建日期",
      ],
      createNameGroupList: ["创意样式", "视频名称", "图片名称", "创建日期"],
      tfContent: {
        nameRule: "",
        package_name: "",
        promotedObjectId: "",
        channelPackageType: "ALL",
        channelPackageItems: "",
        placementType: "VIDEO",
        displaySceneMode: "NOLIMIIT",
        videoCheckList: [],
        gameCheckList: [],
        placement: {
          flowOptimizationEnabled: true,
          displayScene: [],
          siteSet: [],
        },
        autoAudience: false,
        expandEnabled: false,
        expandTargeting: [],
        coldStartAudience: null,
        adNameRule: "",
        isDynamicCreative: false,
        creativeDisplayType: "INTELLIGENCE",
        autoDerivedCreativeEnabled: false,
        labels: [],
        buttonText: "",
        brandImgId: "",
        pendantImageId: "",
        videoOtherSelect: "",
      },
      labelListOptions: [],
      coldStartAudienceList: [],
      uniSelect: "",
      followData: [],
      productList: [],
      rules: {
        nameRule: [
          {
            required: true,
            message: "请输入广告计划名称",
            trigger: ["blur", "change"],
          },
        ],
        promotedObjectId: [
          {
            required: true,
            message: "请选择应用ID",
            trigger: ["blur", "change"],
          },
        ],
        labels: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value.length > 3) {
                callback(new Error("标签最多三个"));
              } else {
                callback();
              }
            },
          },
        ],
        buttonText: [
          {
            required: true,
            message: "请选择按钮文案",
            trigger: ["blur", "change"],
          },
        ],
        brandImgId: [
          {
            required: true,
            message: "请选择品牌形象",
            trigger: ["blur", "change"],
          },
        ],
      },
      // 品牌形象
      brandImageList: [],
      // 挂件图
      pendantImageList: [],
      appidList: [],
      allAppidList: [],
      channelList: {},
      allChannelList: {},
      sameChannelList: [],
      channelAsyncId: "",
      isFirst: true,
    };
  },
  mounted() {
    this.tfContent.videoCheckList = this.videoSelectListOptions.map((item) => {
      return item.value;
    });
    this.tfContent.gameCheckList = this.gameSelectListOptions.map((item) => {
      return item.value;
    });
    this.getAppList();
    this.getLabelList();
    this.getBrandImageList();
    this.getPendantImageList();
  },
  methods: {
    // 获取应用下拉列表
    getAppList(data) {
      getPromotedAppList({
        accountIds: this.advertiserIdList,
        promotedObjectType: this.promotedObjectType,
        isSync: false,
        ...data,
      }).then((res) => {
        this.appidList = res.data;
        if (!data) {
          this.allAppidList = res.data;
        }
      });
    },
    // 获取所有渠道包
    getAllChannelList() {
      getChannelPackageList({
        promotedObjectType: this.promotedObjectType,
        promotedObjectId: this.tfContent.promotedObjectId,
        accountIds: this.advertiserIdList,
      }).then((res) => {
        this.sameChannelList = res.data;
      });
    },
    // 获取推广应用-渠道包
    getChannelPackage(data) {
      getChannelPackageList({
        promotedObjectType: this.promotedObjectType,
        promotedObjectId: this.tfContent.promotedObjectId,
        ...data,
      }).then((res) => {
        this.$set(this.channelList, data.accountIds, res.data);
        if (!this.allChannelList[data.accountIds] || this.allChannelList[data.accountIds]?.length === 0) {
          this.$set(this.allChannelList, data.accountIds, res.data);
        }
      });
    },
    // 获取标签列表
    getLabelList() {
      getPromotedLabelList({ accountId: this.advertiserIdList[0] }).then((res) => {
        res.data.map((item, index) => {
          this.labelListOptions.push({
            value: item.labelCategory,
            label: item.labelCategory,
            children: [],
          });
          if (item.label.length > 0) {
            item.label.map((child) => {
              this.labelListOptions[index].children.push({
                value: {
                  content: child,
                  type: item.labelType,
                  parentContent: item.labelCategory,
                },
                label: child,
                labelType: item.labelType,
              });
            });
          }
        });
      });
    },
    // 获取品牌形象
    getBrandImageList() {
      getBrandAppList({ accountIds: this.advertiserIdList }).then((res) => {
        this.brandImageList = res.data;
        if (this.tfContent.brandImgId) {
          const findObj = this.brandImageList.find((item) => item.imageId === this.tfContent.brandImgId) || {};
          if (!findObj.imageId) {
            this.tfContent.brandImgId = "";
          }
        }
      });
    },
    // 获取挂件图
    getPendantImageList() {
      getImageTemplatelList({ platType: 2, type: 2 }).then((res) => {
        this.pendantImageList = res.data;
      });
    },
    // 删除品牌形象
    deleteBrandImage(type, data) {
      deltetImageTemplatel({ id: data.id }).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          type === "brand" ? this.getBrandImageList() : this.getPendantImageList();
        }
      });
    },
    dropDownSearch() {
      this.appidList = this.allAppidList.filter((item) => item.promotedObjectName.includes(this.promotedObjectAsyncId));
    },
    dropDownSearchChannel(id) {
      this.channelList[id] = this.allChannelList[id].filter((item) => item.packageName.includes(this.channelAsyncId));
    },
    //弹框出现时查询表单数据(父组件调用),表单渲染
    initFormData() {
      const storeData = JSON.parse(JSON.stringify(this.draftAdset));
      this.isFirst = true;
      if (storeData.accountId) {
        this.tfContent = storeData;
        const { nameRule, adNameRule, originalChannelPackageItems } = storeData;
        this.$set(this.tfContent, "nameRule", nameTransforUtil.apiDatatoShow(nameRule));
        this.$set(this.tfContent, "adNameRule", nameTransforUtil.apiDatatoShow(adNameRule));
        this.$set(this.tfContent, "channelPackageItems", originalChannelPackageItems);
      }
    },
    //弹框关闭保存数据到store(父组件调用)
    saveDataInStore() {
      this.saveInStore();
    },
    //弹框关闭时校验数据格式
    checkData() {
      return Promise.all([this.checkCurData()]);
    },
    handleSelectItem(item, itemIndex) {
      const index = this.selectItem.findIndex((item) => item === itemIndex);
      if (index === -1) {
        this.selectItem.push(itemIndex);
        this.tfContent.nameRule += "{" + item + "}";
      } else {
        this.selectItem.splice(index, 1);
        this.tfContent.nameRule = this.tfContent.nameRule.replace("{" + item + "}", "");
      }
    },
    handleSelectCreativeNameItem(item, itemIndex) {
      const index = this.creativeNameSelectItem.findIndex((item) => item === itemIndex);
      if (index === -1) {
        this.creativeNameSelectItem.push(itemIndex);
        this.tfContent.adNameRule += "{" + item + "}";
      } else {
        this.creativeNameSelectItem.splice(index, 1);
        this.tfContent.adNameRule = this.tfContent.adNameRule.replace("{" + item + "}", "");
      }
    },
    saveInStore() {
      //将表单数据转为接口用数据
      let data = JSON.parse(JSON.stringify(this.tfContent));
      const {
        gameCheckList,
        videoCheckList,
        videoOtherSelect,
        placementType,
        promotedObjectId,
        nameRule,
        channelPackageType,
        channelPackageItems,
        adNameRule,
        brandImgId,
      } = data;
      // 源数据为了回显
      data.originalChannelPackageItems = this.tfContent.channelPackageItems;
      if (channelPackageType === "ALL" && this.promotedObjectType === "APP_ANDROID") {
        const findObj = this.sameChannelList.find((item) => item.appAndroidChannelPackageId === channelPackageItems);
        //未选择渠道包
        if (!findObj) {
          data.channelPackageItems = null;
        } else {
          data.channelPackageItems = [
            {
              appAndroidChannelPackageId: channelPackageItems,
              packageName: findObj.packageName,
              sourceAccountId: findObj.accountId,
            },
          ];
        }
      } else if (channelPackageType !== "ALL" && this.promotedObjectType === "APP_ANDROID") {
        //未选择渠道包
        if (!channelPackageItems[0].appAndroidChannelPackageId) {
          data.channelPackageItems = null;
        } else {
          data.channelPackageItems = channelPackageItems.map((item) => {
            const findObj = this.sameChannelList.find((child) => child.appAndroidChannelPackageId === item.appAndroidChannelPackageId);
            item.packageName = findObj.packageName;
            return item;
          });
        }
      } else {
        data.channelPackageItems = null;
      }
      // 投放版位集合
      if (placementType === "VIDEO") {
        data.placement.siteSet = videoCheckList.length > 0 ? videoCheckList : [videoOtherSelect];
      } else {
        data.placement.siteSet = gameCheckList;
      }
      if (brandImgId) {
        const findObj = this.brandImageList.find((item) => item.imageId === brandImgId) || {};
        data.brandName = findObj.name || "";
      }
      // 展示场景
      // 推广应用名称
      data.promotedObjectName = this.allAppidList.find((item) => promotedObjectId === item.promotedObjectId)?.promotedObjectName;
      // 推广应用对应的accountId
      data.accountId = this.allAppidList.find((item) => promotedObjectId === item.promotedObjectId)?.accountId;
      data.nameRule = nameTransforUtil.showDataToApi(nameRule);
      data.adNameRule = nameTransforUtil.showDataToApi(adNameRule);
      this.$store.commit("set_basic_draft_adset_gdt", data);
    },
    //校验投放内容的数据格式
    checkCurData() {
      return Promise.all([
        //投放内容
        this.$refs.selectInputRef.checkData(),
        this.$refs.selectCreateNameRef.checkData(),
        new Promise((resolve, reject) => {
          this.$refs.tfcontentRef.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }),
      ]);
    },
    // changeSystemPicker() {
    //   if (this.tfContent.autoAudience) {
    //     this.tfContent.expandEnabled = false;
    //   }
    // },
    showAddCustomLabelDialog() {
      this.$emit("showAddCustomLabelDialog");
    },
    showAddProductFigureDialog(key) {
      this.$emit("showAddProductFigureDialog", key);
    },
    addCustomLable(text) {
      const newLabelArr = text.split("\n") || [];
      if (newLabelArr.length > 0 && !this.labelListOptions.find((child) => child.value === "custom")) {
        this.labelListOptions.push({
          value: "custom",
          label: "自定义",
          children: [],
        });
      }
      const customObj = this.labelListOptions.find((child) => child.value === "custom");
      newLabelArr.map((item) => {
        customObj.children.push({
          label: item,
          value: {
            content: item,
            type: "CUSTOMIZETEXT",
          },
          labelType: "CUSTOMIZETEXT",
        });
        this.tfContent.labels.push({ content: item, type: "CUSTOMIZETEXT" });
      });
    },
    changeRadioVideo(key) {
      this.tfContent.videoOtherSelect = key;
      this.tfContent.videoCheckList = [];
    },
    changeMultiVideo() {
      if (this.tfContent.videoCheckList.length > 0) {
        this.tfContent.videoOtherSelect = "";
      }
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionGdt.adCount,
      advertiserIdList: (state) => state.PromotionGdt.advertiserIdList,
      promotedObjectType: (state) => state.PromotionGdt.promotedObjectType,
      draftAdset: (state) => state.PromotionGdt.draft_adset,
    }),
  },
  watch: {
    "tfContent.promotedObjectId": {
      handler(val) {
        if (val && this.promotedObjectType === "APP_ANDROID") {
          this.getAllChannelList();
          this.advertiserIdList.map((item) => {
            this.getChannelPackage({ accountIds: item });
          });
        }
      },
      deep: true,
      immediate: true,
    },
    "tfContent.channelPackageType": {
      handler(val) {
        if (!this.isFirst) {
          if (val === "ALL") {
            this.tfContent.channelPackageItems = "";
          } else {
            this.tfContent.channelPackageItems = [];
            this.adCount.map((item) => {
              this.tfContent.channelPackageItems.push({
                sourceAccountId: item.advertiserId,
                company: item.company,
                appAndroidChannelPackageId: "",
                packageName: "",
              });
            });
          }
        } else {
          this.isFirst = false;
        }
      },
      deep: true,
    },
    advertiserIdList() {
      this.tfContent.promotedObjectId = "";
    },
    promotedObjectType() {
      this.tfContent.promotedObjectId = "";
    },
  },
};
</script>

<style lang="less" scoped>
.edit-wrap {
  height: calc(100vh - 63px);
  box-sizing: border-box;
  background: rgba(228, 232, 239, 1);
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  overflow: auto;
  .item-card {
    background-color: #fff;
    padding: 24px;
    margin-bottom: 6px;
    .card-title {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
    }
  }
  // .item-card:not(:last-child) {
  //   margin-bottom: 6px;
  // }
  .card-content {
    margin-top: 20px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .alert {
        background: #edf4ff;
        color: rgba(0, 0, 0, 0.85);
        /deep/ .el-alert__icon {
          color: #0b75ff;
        }
      }
      .form-item {
        display: flex;
        margin-bottom: 20px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 80px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          // padding-top: 6px;
          &.require::before {
            content: "*";
            display: inline-block;
            color: red;
            margin-right: 4px;
          }
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(0, 0, 0, 0.65);
          }
          .name-list {
            padding: 12px 0px 0px 0px;
            margin: 0px;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            .name-item {
              border-radius: 2px;
              border: 1px solid transparent;
              box-sizing: border-box;
              background: rgba(233, 233, 233, 0.6);
              color: rgba(0, 0, 0, 0.85);
              font-size: 12px;
              padding: 2px 6px;
              margin: 0 8px 8px 0px;
              cursor: pointer;
              &.cur {
                border: 1px solid rgba(24, 144, 255, 1);
                background: rgba(225, 240, 255, 1);
                color: rgba(24, 144, 255, 1);
              }
            }
            .show-more {
              color: rgba(24, 144, 255, 1);
              font-size: 13px;
              cursor: pointer;
              margin-left: 20px;
              line-height: 24px;
              i {
                margin-left: 4px;
              }
            }
          }
          .flow-table-wrap {
            margin-top: 12px;
            /deep/ th {
              height: 33px;
              padding: 2px 0;
            }
            /deep/ .el-table td,
            .el-table th {
              padding: 2px 0;
            }
            .header-wrap {
              display: flex;
              .transfor-manage {
                margin-left: auto;
                font-size: 12px;
                color: #409eff;
                cursor: pointer;
              }
            }
          }
        }
      }
      .custom-tip {
        line-height: 32px;
        color: #818181;
        font-size: 12px;
      }
      .ad-part {
        width: 560px;
        border-radius: 4px;
        position: relative;
        padding: 20px;
        .check-item {
          width: 152px;
          margin-top: 10px;
        }
        .scren {
          border-top: 1px solid #eee;
          margin-top: 20px;
          padding-top: 20px;
        }
      }
      .multi-tag {
        position: absolute;
        right: 0;
        top: 0;
        background-color: #edf5ff;
        color: #0b75ff;
        line-height: 24px;
        border-radius: 4px;
        padding: 0 5px;
        font-size: 10px;
      }
      .wx-friend {
        width: 525px;
        display: block;
        padding: 30px 38px;
        margin-right: 0;
        border-bottom: 1px solid #eee;
        position: relative;
        .singal-tag {
          position: absolute;
        }
      }
      .select-border {
        border: 1px solid #0b75ff;
        border-radius: 4px;
      }
      .view-example {
        margin-top: 20px;
        .a-url {
          color: #0b75ff;
          background: transparent;
          text-decoration: none;
          outline: none;
          cursor: pointer;
          -webkit-transition: color 0.2s ease;
          transition: color 0.2s ease;
          font-size: 14px;
        }
      }
    }
  }
  .empty-content {
    height: 200px;
    font-size: 20px;
    margin-left: 10px;
    color: #818181;
    text-align: center;
    line-height: 200px;
  }
}
.el-dropdown-menu {
  /deep/.my-dropdown-select {
    width: 160px;
    padding-left: 10px;
    .el-checkbox {
      display: block;
      line-height: 26px;
    }
    .el-radio {
      display: block;
      line-height: 26px;
      .el-radio__input.is-checked .el-radio__inner {
        color: rgba(24, 144, 255, 1);
        border-color: rgba(24, 144, 255, 1);
        background: rgba(24, 144, 255, 1);
      }
      .el-radio__input.is-checked + .el-radio__label {
        color: rgba(24, 144, 255, 1);
      }
    }
  }
}
</style>

<style lang="less">
.edit-base-set-appid-select {
  .el-scrollbar {
    display: block !important;
  }
  .seitem-wrap {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0px;
    box-sizing: border-box;
    .img-wrap {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      .app-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .seitem-content {
      font-size: 12px;
      .app-detail {
        display: block;
        line-height: 16px;
      }
    }
    .os-icon {
      margin: 0 0px 0 auto;
      font-size: 18px;
    }
  }
}
</style>
